export const templateType = {
    Brochure: 'Brochure',
    Catalog_A: 'Catalog_A',
    Catalog_B: 'Catalog_B',
    Bulletin_A: 'Bulletin_A',
    Bulletin_B: 'Bulletin_B',
    Seed: 'Seed',
};

export type TemplateType = 'Brochure' | 'Catalog_A' | 'Catalog_B' | 'Bulletin_A' | 'Bulletin_B' | 'Seed';


// WEBPACK FOOTER //
// ./src/infrastructure/TemplateType.ts